import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '@/common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const creators = [
  { name: "@NEON_DRIFTER", img: "https://images.unsplash.com/photo-1552374196-1ab2a1c593e8?auto=format&fit=crop&q=80&w=600", frame: "VOID FRAME", location: "Tokyo, JP" },
  { name: "@SARAH.STUDIO", img: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=600", frame: "AURA 01", location: "Berlin, DE" },
  { name: "@MARCUS_X", img: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&q=80&w=600", frame: "CORE X", location: "NYC, US" },
  { name: "@LUNA_V", img: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?auto=format&fit=crop&q=80&w=600", frame: "SPECTRA", location: "London, UK" }
];

const CreatorPicks = () => {
  return (
    <section className="py-32 bg-gray-50 border-y-4 border-black overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 mb-20 flex flex-col md:flex-row justify-between items-end gap-6">
        <div>
          <h2 className="text-5xl md:text-8xl font-black tracking-tighter uppercase leading-[0.85] mb-4">Studio<br/>Collective.</h2>
          <p className="text-gray-500 font-bold uppercase tracking-[0.2em] text-xs">Seen around the world</p>
        </div>
        <a href="#" className="group flex items-center gap-4 font-black text-xs tracking-widest uppercase bg-black text-white px-8 py-4 hover:prism-gradient transition-all">
          FOLLOW THE MOVEMENT <SafeIcon icon={FiIcons.FiInstagram} className="text-xl group-hover:rotate-12 transition-transform" />
        </a>
      </div>

      <div className="flex overflow-x-auto gap-8 px-6 pb-12 no-scrollbar snap-x cursor-grab active:cursor-grabbing">
        {creators.map((creator, i) => (
          <motion.div 
            key={i} 
            className="min-w-[320px] md:min-w-[450px] flex-shrink-0 snap-start group"
            whileHover={{ y: -10 }}
          >
            <div className="relative aspect-[3/4] overflow-hidden border-2 border-black mb-6 bg-white">
              <img 
                src={creator.img} 
                alt={creator.name} 
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105" 
              />
              <div className="absolute inset-0 bg-black/10 group-hover:bg-transparent transition-colors duration-500"></div>
              
              <div className="absolute top-6 right-6">
                <div className="w-12 h-12 rounded-full bg-white/90 backdrop-blur flex items-center justify-center border border-black shadow-lg">
                  <SafeIcon icon={FiIcons.FiMapPin} className="text-black" />
                </div>
              </div>

              <div className="absolute bottom-0 left-0 w-full p-8 translate-y-full group-hover:translate-y-0 transition-transform duration-500 bg-gradient-to-t from-black via-black/80 to-transparent text-white">
                <p className="text-[10px] font-black tracking-[0.3em] uppercase opacity-60 mb-2">Member Series</p>
                <h4 className="text-3xl font-black tracking-tighter uppercase mb-1">{creator.name}</h4>
                <p className="text-sm font-bold text-cyan-400 uppercase tracking-widest">Wearing: {creator.frame}</p>
              </div>
            </div>
            <div className="flex justify-between items-center px-2">
              <span className="font-black text-xs tracking-[0.2em] uppercase">{creator.location}</span>
              <div className="h-[1px] flex-grow mx-4 bg-black/10"></div>
              <span className="font-black text-xs tracking-[0.2em] uppercase">VIEW LOOK</span>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default CreatorPicks;